import { EIconType, ESocialNetworks } from '@common/enums';

export const ICON_NAMES = [
    ESocialNetworks.facebook,
    ESocialNetworks.twitter,
    ESocialNetworks.telegram,
    ESocialNetworks.tiktok,
    ESocialNetworks.instagram,
    ESocialNetworks.youtube,
    ESocialNetworks.linkedin,
    ESocialNetworks.messenger,
    ESocialNetworks.email,
    ESocialNetworks.phone,
];

export const ICON_TYPES = [
    EIconType.logos,
    EIconType.round,
    EIconType.square,
    EIconType.flat,
    EIconType.grey,
    EIconType.outlined,
    EIconType.outlined_white,
    EIconType.white,
];

export const DEFAULT_CHAIN_TYPE = 1;
